var map = {
	"./banner.svg": 4489,
	"./course.svg": 9896,
	"./dashboard.svg": 4145,
	"./drop-down.svg": 3598,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./image-category.svg": 1257,
	"./image.svg": 7501,
	"./online-course.svg": 5911,
	"./password.svg": 6408,
	"./registration-record.svg": 3809,
	"./teacher.svg": 6903,
	"./user.svg": 42,
	"./users.svg": 1034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;